import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Attachment from './Attachment';

import s from './Attachments.scss';

import messages from './messages';

@injectIntl
@withStyles(s)
@connect(state => ({
  lesson: state.lessonDetails.lesson,
  offline: state.online.offline,
}))
export default class Attachments extends React.Component {
  static propTypes = {
    lesson: PropTypes.shape({
      attachments: PropTypes.arrayOf(
        PropTypes.shape({
          _id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          type: PropTypes.string.isRequired,
          size: PropTypes.number.isRequired,
          uploadedDate: PropTypes.string.isRequired,
          path: PropTypes.string.isRequired,
          mimetype: PropTypes.string.isRequired,
        }),
      ),
    }).isRequired,
    withVideo: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    offline: PropTypes.bool.isRequired,
  };

  static contextTypes = {
    apiUrl: PropTypes.string,
  };

  render() {
    const {
      lesson,
      withVideo,
      offline,
      // intl: { formatMessage },
    } = this.props;

    const attachments = _.filter(lesson.attachments, item => !item.isEmbedded);

    if (!_.get(attachments, 'length') || offline) {
      return null;
    }

    return (
      <div>
        <Typography component="h3" variant="h5" className={s.title}>
          <FormattedMessage {...messages.title} />
        </Typography>
        <div>
          {attachments.map(item => (
            <Attachment key={item._id} item={item} withVideo={withVideo} />
          ))}
        </div>
      </div>
    );
  }
}
